/* import __COLOCATED_TEMPLATE__ from './need-more-hardware-banner.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();